var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.707 16.325a1 1 0 00-1.414 0l-5.627 5.628-2.688-2.653a1 1 0 00-1.435 1.4l2.744 2.7a1.876 1.876 0 001.345.6h.033A1.873 1.873 0 0018 23.447l5.707-5.708a1 1 0 000-1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 21.959A10 10 0 1122 12c0 .307-.015.611-.041.911A1 1 0 0022.866 14a.989.989 0 001.085-.907c.032-.363.049-.726.049-1.093a12 12 0 10-13.09 11.951h.091a1 1 0 00.089-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7v4.586l-2.707 2.707a1 1 0 101.414 1.414l3-3A1 1 0 0013 12V7a1 1 0 00-2 0z"
  })));
}
export default SvgTimeCheck;